import { react2angular } from 'react2angular';
import EditCriteriaPanel from './EditCriteriaPanel';

angular
  .module('analysis.module')
  .component('editCriteriaPanel', react2angular(EditCriteriaPanel, [
    'selection',
    'consistOptions',
    'carOptions',
    'subsystemOptions',
    'eventOptions',
    'envDataFields',
    'envDataFieldValues',
    'envDataFieldMetadata',
    'showCriteriaFilters',
    'showCars',
    'showSubsystems',
    'showEvents',
    'showDates',
    'dateWindowMode',
    'dateWindowValue',
    'dateWindowUnits',
    'dateWindowDefaultHours',
    'showEnvironmentQuery',
    'showEnvGetDataButton',
    'initiallyCollapseEnvironmentQuery',
    'onSelectionChange',
    'onEnvFiltersChanged',
    'onEnvQueryValidityChange',
    'onDateWindowModeChange',
    'onDateWindowValueChange',
    'onDateWindowReset',
  ]));